import { useTranslator } from "components/Translator"
import { DescriptionsList, DescriptionItem } from "components/DescriptionsList"
import { AccordionSection } from "components/Accordion"

export const BoatEnergy = (props) => {
  const { boat } = props

  const translator = useTranslator()

  return boat ? (
    <AccordionSection
      label={translator.trans("BoatEnergy.title", null, "components")}
    >
      <DescriptionsList>
        <DescriptionItem
          label={translator.trans("BoatEnergy.engineBrand", null, "components")}
          value={boat.engineBrand}
        />
        <DescriptionItem
          label={translator.trans("BoatEnergy.engineNb", null, "components")}
          value={boat.engineNb}
        />
        <DescriptionItem
          label={translator.trans("BoatEnergy.enginePower", null, "components")}
          value={boat.enginePower}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.fuelCapacity",
            null,
            "components",
          )}
          value={boat.fuelCapacity}
        />
        <DescriptionItem
          label={translator.trans("BoatEnergy.fuelType", null, "components")}
          value={boat.fuelType}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.electricCharge12V",
            null,
            "components",
          )}
          value={boat.electricCharge12V}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.electricCharge220V",
            null,
            "components",
          )}
          value={boat.electricCharge220V}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.batteryTotalCapacity",
            null,
            "components",
          )}
          value={boat.batteryTotalCapacity}
        />
        <DescriptionItem
          label={translator.trans("BoatEnergy.voltage", null, "components")}
          value={boat.voltage}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.engineAlternator",
            null,
            "components",
          )}
          value={boat.engineAlternator}
        />
        <DescriptionItem
          label={translator.trans("BoatEnergy.solarPanel", null, "components")}
          value={boat.solarPanel}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.hydrogenerator",
            null,
            "components",
          )}
          value={boat.hydrogenerator}
        />
        <DescriptionItem
          label={translator.trans("BoatEnergy.windTurbine", null, "components")}
          value={boat.windTurbine}
        />
        <DescriptionItem
          label={translator.trans(
            "BoatEnergy.electricGenerator",
            null,
            "components",
          )}
          value={boat.electricGenerator}
        />
      </DescriptionsList>
    </AccordionSection>
  ) : null
}
